export const normalizeRuPhone = (phone: string): string => {
  if (!phone) return "";

  const digits = phone.replace(/\D/g, "");

  if (digits.length === 11 && digits.startsWith("7")) {
    return digits.slice(1);
  }

  if (digits.length === 11 && digits.startsWith("8")) {
    return digits.slice(1);
  }

  if (digits.length === 10) {
    return digits;
  }

  return "";
};